import React from "react";
import classNames from "classnames";
import GridContainer from "../../../components/Grid/GridContainer.jsx";
import GridItem from "../../../components/Grid/GridItem.jsx";
import withStyles from "@material-ui/core/styles/withStyles";

import descriptionStyle from "../../../assets/jss/material-kit-pro-react/views/aboutUsSections/descriptionStyle.jsx";

function CovidAdviceSection(props) {
  const { classes } = props;
  return (
    <div className={classNames(classes.textJustified)}>
      <GridContainer>
        <GridItem
          md={8}
          sm={8}
          className={classNames(classes.mrAuto, classes.mlAuto, classes.focusedContainer)}
        >
          <h4><strong>Vivamos el Campo te invita a adoptar protocolos de bioseguridad para así evitar la propagación del COVID 19</strong></h4>
          <h5 className={classes.description}>
            Queremos que disfrutes tu estadía teniendo presente los cuidados que debes tener en cuenta para cuidarte
            a ti y a tu familia ante la amenaza del COVID-19, por eso te recomendamos llevar a cabo las siguientes acciones:
            <ul>
              <li>Lavado de manos de manera frecuente</li>
              <li>El uso de tapabocas</li>
            </ul>
          </h5>
        </GridItem>
      </GridContainer>
    </div>
  );
}

export default withStyles(descriptionStyle)(CovidAdviceSection);



// WEBPACK FOOTER //
// ./src/views/LandingPage/Sections/CovidAdviceSection.jsx